var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaterialUi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 23,
    viewBox: "0 0 28 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_448_1053",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 23
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.2328 0.649902H0V22.3499H27.2328V0.649902Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_448_1053)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 12.4863V0.652344L10.2123 6.5693V10.5139L3.40409 6.5693V14.4585L0 12.4863Z",
    fill: "#00B0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2123 6.5693L20.4246 0.652344V12.4863L13.6164 16.4308L10.2123 14.4585L17.0205 10.5139V6.5693L10.2123 10.5139V6.5693Z",
    fill: "#0081CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2123 14.4585V18.4031L17.0205 22.3477V18.4031L10.2123 14.4585Z",
    fill: "#00B0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0204 22.3478L27.2327 16.4308V8.54162L23.8286 10.5139V14.4585L17.0204 18.4032V22.3478ZM23.8286 6.5693V2.62466L27.2327 0.652344V4.59698L23.8286 6.5693Z",
    fill: "#0081CB"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialUi);
export default __webpack_public_path__ + "static/media/MaterialUI.e9b4fabbe63c319d8745b8ccbc0e43e3.svg";
export { ForwardRef as ReactComponent };